import React from 'react';
import { usePrefixCls } from '@byte-design/config';
import { Step } from './Step';
export function StepDot(props) {
  var cls = usePrefixCls('step-dot');
  return React.createElement(Step, Object.assign({
    content: React.createElement("div", {
      className: cls
    })
  }, props));
}